import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showStatistic: false
  },
  mutations: {
    setShowStatistic(state, value) {
      state.showStatistic = value
    }
  },
  actions: {

  }
})
